import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { useFormik } from "formik";
import * as Yup from "yup";

import { getMimarConstantsRequest, updateAppConstants } from '../../../../store/Settings/actions'
import { ROUTE_PATHS } from '../../../../utils/RoutesPaths';
import { setPageMainTitle } from '../../../../utils/Helpers';
import { POSITIVE_FLOAT_REGEX } from '../../../../utils/Patterns'
import messages from "../../../../assets/locale/messages";
import Breadcrumbs from '../../../../components/BreadCrumbs';
import Input from '../../../../components/Input';
import Button from '../../../../components/Button';

const EditMimarConstants = () => {

    const dispatch = useDispatch()
    const history = useHistory();
    const lang = useSelector((state) => state.locale.lang);
    const mimarConstansts = useSelector((state) => state.settings.mimarConstansts);
    const { settings, shared } = messages[lang];

    const {values,
        handleSubmit,
        setFieldTouched,
        setFieldValue,
        touched, 
        errors
       } = useFormik({
                initialValues: {
                    vat: 0,
                    onlineFees: 0,
                    mimarsCommission: 0,
                    fixedFees: 0,
                    commissionStartsAfter: 0
                },
                validationSchema: Yup.object({
                                    vat: Yup.string().required("This field is required").matches(POSITIVE_FLOAT_REGEX,'positiveNumber'),
                                    onlineFees: Yup.string().required("This field is required").matches(POSITIVE_FLOAT_REGEX,'positiveNumber'),
                                    mimarsCommission: Yup.string().required("This field is required").matches(POSITIVE_FLOAT_REGEX,'positiveNumber'),
                                    fixedFees: Yup.string().required("This field is required").matches(POSITIVE_FLOAT_REGEX,'positiveNumber'),
                                    commissionStartsAfter: Yup.string().required("This field is required").matches(POSITIVE_FLOAT_REGEX,'positiveNumber'),
                }),
                onSubmit: async ({ vat, onlineFees, mimarsCommission, fixedFees, commissionStartsAfter }) => {
                    const params = {
                        vat: +vat,
                        online_fees: +onlineFees,
                        mimars_commission: +mimarsCommission,
                        fixed_fees: +fixedFees,
                        commission_threshold: +commissionStartsAfter
                    };
                    dispatch(updateAppConstants({
                        data: params,
                        from:'mimarConstants'
                    }));
                }
    });

    useEffect(() => {
        setPageMainTitle('SettingsManagment');
        dispatch(getMimarConstantsRequest());
    }, []);

    useEffect(() => {
        if(Object.keys(mimarConstansts).length){
            setFieldValue( "vat" , mimarConstansts.vat);
            setFieldValue("onlineFees" , mimarConstansts.onlineFees);
            setFieldValue("mimarsCommission" , mimarConstansts.mimarsCommission);
            setFieldValue("fixedFees" , mimarConstansts.fixedFees);
            setFieldValue("commissionStartsAfter" , mimarConstansts.commissionThreshold);
        }
    },[mimarConstansts]);

    return(
        <div>
            <Breadcrumbs
                list={[
                    {
                        path: ROUTE_PATHS.mimarConstants,
                        label: settings.viewSettings.mimarConstants
                    },
                    {
                        path: "#",
                        label: shared.edit
                    }
                ]}
                className="fsize-28 fweight-600 mb-4" 
            />
            <form onSubmit={handleSubmit}>
                <div className="bg-white rounded-4 px-5 py-4 mb-4 fweight-400">
                    <div
                        className="text-secondary mb-3 fsize-18"
                    >
                        {settings.mimarConstants.vat}
                        <span className="text-primary fweight-700"> *</span>
                    </div>
                    <Input
                        id="vat"
                        name="vat"
                        type="text"
                        placeholder={settings.mimarConstants.vatPlaceholder}
                        inputClass="mb-1"
                        value={values["vat"]}
                        onChange={(value) => {
                                setFieldTouched("vat");
                                setFieldValue("vat", value);
                          }}
                        isInputHasErr={!!(touched["vat"] && errors["vat"])}
                        errMsg={errors["vat"]}
                    />
                </div>
                <div className="bg-white rounded-4 px-5 py-4 mb-4  fweight-400">
                    <div
                        className="text-secondary mb-3 fsize-18"
                    >
                        {settings.mimarConstants.onlineFees}
                        <span className="text-primary fweight-700"> *</span>
                    </div>
                    <Input
                        id="onlineFees"
                        name="onlineFees"
                        type="text"
                        placeholder={settings.mimarConstants.onlineFeesPlaceholder}
                        inputClass="mb-3"
                        value={values["onlineFees"]}
                        onChange={(value) => {
                            setFieldTouched("onlineFees");
                            setFieldValue("onlineFees", value);
                          }}
                        isInputHasErr={!!(touched["onlineFees"] && errors["onlineFees"])}
                        errMsg={errors["onlineFees"]}
                    />    
                </div>
                <div className="bg-white rounded-4 px-5 py-4 mb-4 fweight-400">
                    <div
                        className="text-secondary mb-3 fsize-18"
                    >
                        {settings.mimarConstants.mimarCommission}
                        <span className="text-primary fweight-700"> *</span>
                    </div>
                    <Input
                        id="mimarsCommission"
                        name="mimarsCommission"
                        type="text"
                        placeholder={settings.mimarConstants.mimarCommissionPlaceholder}
                        inputClass="mb-3"
                        value={values["mimarsCommission"]}
                        onChange={(value) => {
                            setFieldTouched("mimarsCommission");
                            setFieldValue("mimarsCommission", value);
                          }}
                        isInputHasErr={!!(touched["mimarsCommission"] && errors["mimarsCommission"])}
                        errMsg={errors["mimarsCommission"]}
                    />
                </div>
                <div className="bg-white rounded-4 px-5 py-4 mb-4 fweight-400">
                    <div
                        className="text-secondary mb-3 fsize-18"
                    >
                        {settings.mimarConstants.fixedFees}
                        <span className="text-primary fweight-700"> *</span>
                    </div>
                    <Input
                        id="fixedFees"
                        name="fixedFees"
                        type="text"
                        placeholder={settings.mimarConstants.fixedFeesPlaceholder}
                        inputClass="mb-3"
                        value={values["fixedFees"]}
                        onChange={(value) => {
                            setFieldTouched("fixedFees");
                            setFieldValue("fixedFees", value);
                          }}
                        isInputHasErr={!!(touched["fixedFees"] && errors["fixedFees"])}
                        errMsg={errors["fixedFees"]}
                    />
                </div>
                <div className="bg-white rounded-4 px-5 py-4 mb-4 fweight-400">
                    <div
                        className="text-secondary mb-3 fsize-18"
                    >
                        {settings.mimarConstants.commissionStartsAfter}
                        <span className="text-primary fweight-700"> *</span>
                    </div>
                    <Input
                        id="commissionStartsAfter"
                        name="commissionStartsAfter"
                        type="text"
                        placeholder={settings.mimarConstants.commissionStartsAfterPlaceholder}
                        inputClass="mb-3"
                        value={values["commissionStartsAfter"]}
                        onChange={(value) => {
                            setFieldTouched("commissionStartsAfter");
                            setFieldValue("commissionStartsAfter", value);
                          }}
                        isInputHasErr={!!(touched["commissionStartsAfter"] && errors["commissionStartsAfter"])}
                        errMsg={errors["commissionStartsAfter"]}
                    />
                </div>

                
                <div className= "d-flex justify-content-end gap-2">
                    <Button
                        label={shared.cancel}
                        labelClass="text-secondary px-3"
                        outlined
                        onClick={()=> {history.push(ROUTE_PATHS.mimarConstants)}}
                    />
                    <Button
                        type="sumbit"
                        label={shared.save}
                        labelClass="text-white px-3"
                        btnStyle="secondary"
                        onClick={()=> {handleSubmit()}}
                        disabled={!!(errors["vat"] || errors["onlineFees"] || errors["mimarsCommission"])}
                    />
                </div>
            </form>
        </div>
    );
}

export default EditMimarConstants;